import { Component, OnInit, Input } from '@angular/core';
import { BotonTipo } from '../boton/boton';
import { DetalleService } from '../../providers/detalle.service';

@Component({
  selector: 'app-detalle',
  templateUrl: './detalle.component.html',
  styleUrls: ['./detalle.component.scss']
})
export class DetalleComponent implements OnInit {
  @Input() titulo: string;
  @Input() id: number;
  @Input() link: string;
  @Input() type: BotonTipo;
  @Input() tooltipDir: string = "below";

  _disabled: boolean;
  @Input() public set disabled(v: boolean) {
    this._disabled = v;
  }
  public get disabled(): boolean {
    return this._disabled;
  }

  constructor(
    private detalleService: DetalleService
  ) { }

  ngOnInit() {
    if (!this.titulo) {
      throw "La variable Input 'titulo' es requerida";
    }
    if (!this.id) {
      throw "La variable Input 'id' es requerida";
    }
    if (!this.link) {
      throw "La variable Input 'link' es requerida";
    }
  }

  irAlDetalle(): void {
    this.detalleService.reiniciarTabDetalle('DETALLE_' + this.titulo);
  }
}
